import { FC } from 'react';

const Pause: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      className={className}
    >
      <path
        d="M10.2857 1.11111C10.2857 0.497462 10.7974 0 11.4286 0H14.8571C15.4883 0 16 0.497461 16 1.11111V18.8889C16 19.5025 15.4883 20 14.8571 20H11.4286C10.7974 20 10.2857 19.5025 10.2857 18.8889V1.11111Z"
        fill="white"
      />
      <path
        d="M0 1.11111C0 0.497462 0.511675 0 1.14286 0H4.57143C5.20261 0 5.71429 0.497461 5.71429 1.11111V18.8889C5.71429 19.5025 5.20261 20 4.57143 20H1.14286C0.511675 20 0 19.5025 0 18.8889V1.11111Z"
        fill="white"
      />
    </svg>
  );
};

export default Pause;
